module.exports = __webpack_public_path__ + "static/img/zejiangdaxue.beb5d0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/zejiangdaxue.jpg
// module id = u2KR
// module chunks = 36